<template>
  <div class="container" id="container">
    <div id="dashboard" >
      <!-- Dashboard header -->
      <div class="dashboard__header mb-4 row no-gutters">

        <!-- Dashboard Title -->
        <div class="col-sm-12 col-md-4 pt-md-1 pt-sm-0 dashboard__header--col" ref="topTitle">
          <div>
            <svg class="dashboard__header--icon h-100 display-inline-block" width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8393 0.5625C6.19596 0.5625 0 6.8584 0 14.625C0 17.2031 0.684756 19.6182 1.87695 21.6953C2.14653 22.165 2.66022 22.4375 3.19553 22.4375H24.483C25.0184 22.4375 25.532 22.165 25.8016 21.6953C26.9938 19.6182 27.6786 17.2031 27.6786 14.625C27.6786 6.8584 21.4826 0.5625 13.8393 0.5625ZM21.6815 9.07861L16.4654 16.1455C16.7446 16.6157 16.9147 17.1606 16.9147 17.75C16.9147 18.3223 16.7523 18.8511 16.488 19.3125H11.1906C10.9263 18.8511 10.7639 18.3223 10.7639 17.75C10.7639 16.0239 12.1406 14.625 13.8393 14.625C14.1108 14.625 14.3688 14.6719 14.6197 14.7393L19.8363 7.67139C20.2198 7.15576 20.9415 7.05029 21.4514 7.43701C21.9603 7.82568 22.064 8.56055 21.6815 9.07861Z" fill="#2B4D75"/></svg>
            <h1 class="dashboard__header--title m-0 header">Admin Dashboard</h1>
            <!-- <button class="btn btn--white" @click="getTemplate()">Generate</button> -->
          </div>
        </div>

        <!-- Date Range -->
        <div class="col-sm-12 col-md-8 text-right dashboard__header--col-right">
          <div class="dashboard__header--picker display-table-cell mt-sm-2 mt-md-2 mt-lg-0 display-inline-block">
            <date-range-picker @toggle="detectDateRangeState" v-clickaway="closeDateRangePicker" @update="updateDatee" ref="picker" opens="left" :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY', applyLabel: 'Apply', cancelLabel: 'Cancel' }" :showWeekNumbers="false" :timePicker="false" :autoApply="false" v-model="showDateRange" placeholder="mm/dd/yyyy">
              <div slot="input" slot-scope="picker">
                  <button class="btn btn--white display-table px-3" ref="btn-picker">
                      <svg class="display-table-cell mr-2" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 15.4062C0 16.2861 0.713867 17 1.59375 17H13.2812C14.1611 17 14.875 16.2861 14.875 15.4062V6.375H0V15.4062ZM2.125 9.03125C2.125 8.73906 2.36406 8.5 2.65625 8.5H12.2188C12.5109 8.5 12.75 8.73906 12.75 9.03125V11.1562C12.75 11.4484 12.5109 11.6875 12.2188 11.6875H2.65625C2.36406 11.6875 2.125 11.4484 2.125 11.1562V9.03125ZM13.2812 2.125H11.6875V0.53125C11.6875 0.239062 11.4484 0 11.1562 0H10.0938C9.80156 0 9.5625 0.239062 9.5625 0.53125V2.125H5.3125V0.53125C5.3125 0.239062 5.07344 0 4.78125 0H3.71875C3.42656 0 3.1875 0.239062 3.1875 0.53125V2.125H1.59375C0.713867 2.125 0 2.83887 0 3.71875V5.3125H14.875V3.71875C14.875 2.83887 14.1611 2.125 13.2812 2.125Z" fill="#52749C"/>
                      </svg>
                      <!-- <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['This year'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['This year'][1]) == dateFormat(picker.endDate)">This Year: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['This month'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['This month'][1]) == dateFormat(picker.endDate)">This Month: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['Last week'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['Last week'][1]) == dateFormat(picker.endDate)">Last Week: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['Last month'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['Last month'][1]) == dateFormat(picker.endDate)">Last Month: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges.Today[0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges.Today[1]) == dateFormat(picker.endDate)">Today: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges.Yesterday[0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges.Yesterday[1] == picker.endDate)">Yesterday: </span> -->
                      <span class="display-table-cell" v-if="picker.startDate == null && picker.endDate == null">Select date range</span>
                      <span class="display-table-cell mx-2" v-else>{{dateFormat(picker.startDate)}} - {{dateFormat(picker.endDate)}}</span>
                      <svg class="display-table-cell" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.594098 0.908325L8.22252 0.908325C8.75074 0.908325 9.01526 1.54697 8.64176 1.92047L4.82755 5.73468C4.59602 5.96621 4.2206 5.96621 3.98907 5.73468L0.174856 1.92047C-0.198674 1.54697 0.0658798 0.908325 0.594098 0.908325Z" fill="#52749C"/>
                      </svg>
                  </button>
              </div>
            </date-range-picker>
          </div>
        </div>

      </div>

      <!-- Dashboard Charts -->
      <!-- <div class="dashboard__header mb-3 row no-gutters" style="margin: 0 -7.5px">

      </div> -->
      <div class="dashboard__header mb-4 row no-gutters" style="margin: 0 -7.5px">
        
        <!-- new Charts -->
        <!--  Active Users -->
        <div class="col-sm-6 col-lg-4 mb-3 dashboard__header--col" style="padding: 0 7.5px;min-height:60px;">
          <mini-chart class="display-flex flex-col justify-content-center" :hideCanvas="true" chartType="active_users" :subType="null" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate" ></mini-chart>
        </div>

        <!--  Churn Rate -->
        <div class="col-sm-6 col-lg-4 mb-3 dashboard__header--col" style="padding: 0 7.5px;min-height:60px;">
          <mini-chart class="display-flex flex-col justify-content-center" :hideCanvas="true" chartType="churn_rate" :subType="null" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div>

        <!--  Conversion Rate -->
        <div class="col-sm-6 col-lg-4 mb-3 dashboard__header--col" style="padding: 0 7.5px;min-height:60px;">
          <mini-chart class="display-flex flex-col justify-content-center" :hideCanvas="true" chartType="conversion_rate" :subType="null" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div>


        <!--  Accounts -->
        <div class="col-sm-6 col-md-3 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="accounts" :subType="null" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate" ></mini-chart>
        </div>

        <!--  Subscriptions -->
        <div class="col-sm-6 col-md-3 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="subscriptions" subType="active" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div>

        <!--  Charges -->
        <div class="col-sm-6 col-md-3 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="charges" subType="succeeded" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div>

        <!--  Tasks -->
        <div class="col-sm-6 col-md-3 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="tasks" subType="Done" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div>

        <!--  Method Payement -->
        <div class="col-sm-6 col-lg-4 mt-3 dashboard__header--col" style="padding: 0 7.5px;height: 280px;">
          <pie-chart chartType="method_payment" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></pie-chart>
        </div>

        <!--  Sign Up -->
        <div class="col-sm-6 col-lg-4 mt-3 dashboard__header--col" style="padding: 0 7.5px;height: 280px;">
          <pie-chart chartType="platforms" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></pie-chart>
        </div>

        <!--  Sign Up -->
        <div class="col-sm-6 col-lg-4 mt-3 dashboard__header--col" style="padding: 0 7.5px;height: 280px;">
          <pie-chart chartType="signup" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></pie-chart>
        </div>

        <div class="col-sm-12 col-md-6 mt-3 dashboard__header--col" style="padding: 0 7.5px;">
          <!-- <pie-chart chartType="signup" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></pie-chart> -->
          <s-card class="dashboard-header-charts__card h-100" style="cursor: initial;">
            <!-- Header Chart Normal -->
            <s-card-header class="dashboard-header-charts__header border-bottom">
                <div class="display-table w-100">
                <p class="font-weight-bold display-table-cell w-100 mr-1">{{'Current connected Users'}}</p>
                <p class="display-table-cell text-right font-weight-bold" id="connectedUsers" v-show="!loadingConnectedAccounts">{{$store.state.currentConnectedUsers}}</p>
                </div>
            </s-card-header>
            <!-- Body Chart Normal -->
            <div v-if="!loadingConnectedAccounts">
              <s-card-header class="p-2 bg-white">
                <div class="row no-gutters">
                  <div class="col-4 font-weight-sbold text-uppercase text-secondary" style="font-size:14px;">Account Id</div>
                  <div class="col-4 font-weight-sbold text-uppercase text-secondary" style="font-size:14px;">Sessions</div>
                  <div class="col-4 font-weight-sbold text-uppercase text-secondary" style="font-size:14px;">Action</div>
                </div>
              </s-card-header>
              <s-card-body class="p-0" style="max-height: 500px; overflow-y: auto;">
                <div v-for="(account,indexAccount) in listConnectedAccounts" :class="indexAccount>0 ? 'border-top':''" :key="indexAccount" class="p-2">
                  <div class="row no-gutters" >
                    <div class="col-4 display-table-cell">
                      <p class="display-table-cell">{{account.account_id}}</p>
                    </div>
                    <div class="col-4 display-table-cell">
                      <p class="display-table-cell">{{account.sessions}}</p>
                    </div>
                    <div class="col-4 display-table-cell">
                      <a :href="`/account/${account.account_id}`" class="btn btn--primary display-table-cell">
                        <span class="display-table-cell">Details</span>
                      </a>
                      <!-- <button class="btn btn--primary display-table-cell" @click="showAccountDetails(account.account_id)">Details</button> -->
                    </div>
                  </div>
                </div>
              </s-card-body>
              <s-card-body v-if="!listConnectedAccounts.length" class="p-2 text-center">
                No Account connected
              </s-card-body>
            </div>
            <!-- Loader -->
            <s-card-body v-if="loadingConnectedAccounts" class="padding-4 w-100 text-center">
                <!-- <div v-if="true" class="loader-chart"> -->
                    <s-loader :type="'scalify'"></s-loader>
                <!-- </div> -->
            </s-card-body>
          </s-card>
        </div>
        <div class="col-sm-12 col-md-6 mt-3 dashboard__header--col" style="padding: 0 7.5px;">
          <s-card class="dashboard-header-charts__card h-100" style="cursor: initial;">
            <!-- Header Chart Normal -->
            <s-card-header class="dashboard-header-charts__header border-bottom">
                <div class="display-table w-100">
                  <p class="font-weight-bold display-table-cell w-100 mr-1">Chosen Plans</p>
                </div>
            </s-card-header>
            <s-card-body class="padding-4 w-100 text-center">
              <div id="products-table">
                <s-card class="products-table__card border-top-0 p-0">
                  <s-card-body class="product-table__table p-0">
                      <div class="product-table__table-container" @scroll="getScrollPos">
                          <div class="div-shadow-left" v-if="!hideShadows && scrollIn && scrollIn !== 'left' && plansList && plansList.length"></div>
                          <!-- plansList && plansList.length &&  -->
                          <table v-if="!loading" class="product-table__table--table" style="width: 100% !important;" id="myTable">
                              <thead class="product-table__table--header border-0 p-0 mb-4">
                                  <!-- Count -->
                                  <td class="text-truncate product-table__table--header-id" style="width: 20% !important;">
                                      <span>Count</span>
                                  </td>
                                  <!-- Name -->
                                  <td class="text-truncate product-table__table--header-joined" style="width: 20% !important;">
                                      <span>Name</span>
                                  </td>
                                  <!-- Interval -->
                                  <td class="text-truncate product-table__table--header-joined cursor-pointer" style="width: 20% !important;">
                                      <span>Interval</span>
                                  </td>
                                  <!-- price -->
                                  <td class="text-truncate product-table__table--header-joined cursor-pointer" style="width: 20% !important;">
                                    <span>price</span>
                                  </td>
                                  <!-- Max Adspend -->
                                  <td class="text-truncate product-table__table--header-trail-started" style="width: 20% !important;">
                                      <span>Max Adspend</span>
                                  </td>
                              </thead>
                              <tbody v-if="plansList && plansList.length > 0" class="product-table__table--body" >
                                <div style="max-height: 500px; overflow-y: auto; display: grid;">
                                  <tr class="w-100 display-table-cell" v-if="!loading && (plansList == null || plansList.length == 0)">
                                      <p class="my-3 position-relative font-weight-sbold" style="left:40%;">No Results</p>
                                  </tr>
                                  <tr v-show="!loading" v-for="(plan, plantIndex) in plansList" :key="plantIndex" class="product-table__table--row">
                                      <!-- Count -->
                                      <td  class="display-table-cell product-table__table--body-id" style="width: 20% !important;">
                                        <p class="text-truncate">{{plan.count}}</p>
                                      </td>
                                      <!-- Name -->
                                      <td :tooltip-position="plantIndex==0?'right':'top'" :tooltip="plan.name" class="display-table-cell product-table__table--body-joined" style="width: 20% !important;">
                                        <p  class="text-truncate">{{plan.name}}</p>
                                      </td>
                                      <!-- Interval -->
                                      <td class="display-table-cell product-table__table--body-joined" style="width: 20% !important;">
                                        <p  class="text-truncate">{{plan.interval}}</p>
                                      </td>
                                      <!-- Price -->
                                      <td class="display-table-cell product-table__table--body-joined" style="width: 20% !important;">
                                          <p class="text-truncate">{{plan.price}}</p>
                                      </td>
                                      <!-- Max AdSpend -->
                                      <td class="display-table-cell product-table__table--body-joined" style="width: 20% !important;">
                                          <p class="text-truncate">{{plan.max_adspend}}</p>
                                      </td>
                                  </tr>
                                </div>
                              </tbody>
                          </table>
                          <div class="div-shadow-right" v-if="!hideShadows && scrollIn && scrollIn !== 'right' && ((plansList && plansList.length))"></div>
                      </div>
                  </s-card-body>
                </s-card>
              </div>
            </s-card-body>
          </s-card>
        </div>

      </div>

      <!-- <div class="display-table mb-4">
        <svg class="mr-2 display-table-cell" width="34" height="30" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.352 1.97205C21.0187 1.41277 19.6842 1.2 18.3505 1.2C14.1166 1.19965 9.88305 3.3429 5.64915 3.3429C4.58732 3.3429 3.52618 3.20815 2.46435 2.87128C2.34507 2.83347 2.22545 2.8156 2.10858 2.8156C1.51699 2.8156 1 3.27346 1 3.90905V14.8147C1 15.2488 1.24853 15.6603 1.64761 15.8274C2.981 16.387 4.31542 16.5998 5.64915 16.5998C9.88305 16.5998 14.117 14.4565 18.3509 14.4565C19.4127 14.4565 20.4738 14.5913 21.5356 14.9281C21.6549 14.9659 21.7745 14.9838 21.8914 14.9838C22.483 14.9838 23 14.5259 23 13.8904V2.98506C22.9997 2.55057 22.7511 2.13945 22.352 1.97205ZM11.9998 12.1998C10.4808 12.1998 9.24987 10.7221 9.24987 8.89987C9.24987 7.07734 10.4812 5.59993 11.9998 5.59993C13.5185 5.59993 14.7498 7.07734 14.7498 8.89987C14.7498 10.7228 13.5181 12.1998 11.9998 12.1998Z" fill="#2B4D75"/>
        </svg>
        <h2 class="display-table-cell mb-0">Chosen Plans</h2>
      </div> -->


    </div>
  </div>
</template>

<script>
import moment from 'moment';
import MiniChart from './MiniChart.vue';
import PieChart from './PieChart.vue';
import DateRangePicker from 'vue2-daterange-picker';
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


export default {
  name: 'dashboard',

  components:{
    MiniChart,
    PieChart,
    DateRangePicker
  },

  props: {},

  computed:{
  },

  data(){
    return{
      showDateRange: {},
      valueUpdateDate: null,
      showRangePicker:false,
      plansList: [],
      listAccounts:[],
      showColumns: false,
      loading:false,
      hideShadows:false,
      scrollIn:"left"
    }
  },

  methods:{
    // showAccountDetails(id){
    //   this.$router.replace({name:'account-details',params:{id:id}})
    // },
    closeDateRangePicker(){
      this.$nextTick(()=>{
        if(this.showRangePicker){
          this.$refs["btn-picker"].click()
        }
      })
    },
    detectDateRangeState(show){
      this.showRangePicker = show
    },
    async updateDatee(value){
      this.valueUpdateDate = value;
    },
    dateFormat(date){
      const m = moment(date);
      const ord = m.format("ll");
      return ord;
    },
    getScrollPos ({ target: { scrollLeft ,clientWidth, scrollWidth }}) {
      var scroll = "left"
      if(scrollLeft == 0){
          scroll = "left"
      }
      else if(scrollLeft+clientWidth < scrollWidth){
          scroll = "middle"
      }
      if(scrollLeft+clientWidth >= scrollWidth){
          scroll = "right"
      }
      this.scrollIn = scroll
    },
    updateTableWidth(){
      this.$nextTick(()=>{
        var x = document.getElementById("myTable")
        if(x){
            var items = x.children[0].children
            var w = 0
            for(var i=0;i<items.length;i++){
                w = w + items[i].clientWidth
            }
            if(parseInt(w) < 1110){
                this.hideShadows = true
            }
            else{
                this.hideShadows = false
            }
            x.style.width=w+'px'
            this.$forceUpdate()
        }
      })
    }
  },

  async created(){
    this.showDateRange = {};
    this.showDateRange['endDate'] = new Date();
    var makeDate = new Date();
    this.showDateRange['startDate'] = new Date(new Date().setMonth(makeDate.getMonth()-1));
  },

  watch:{


  },

  async mounted(){


    const plans = await this.plansTable();
    // console.log('plans: ', plans);
    if (plans && plans.data) {
      this.plansList = plans.data;
    }

  }


}
</script>

<style scoped>

</style>
